import { formatMoney } from '@shopify/theme-currency';

// Custom wishlist landing and cart page
const productTileMarkup = `
  <div class="cart-wishlist__item cart-wishlist-item" data-cart-wishlist-item data-cart-wishlist-item-id="{{id}}">
    <div class="cart-wishlist-item__top">
      <a href="{{du}}"><img loading="lazy" class="cart-wishlist-item__image" src="{{iu}}" alt="Your list item" width="275" /></a>
    </div>

    <div class="cart-wishlist-item__bottom">
      <p class="cart-wishlist-item__title" data-cart-wishlist-item-title>{{dt}}</p>
      <p class="cart-wishlist-item__options" data-cart-wishlist-item-options>{{variants}}</p>
      <p class="cart-wishlist-item__price" data-cart-wishlist-item-price><span class="money">{{pr_formatted}}</span></p>
    </div>

    <div class="cart-wishlist-item__buttons">
      <a href="javascript: void(0);" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="move-to-cart cart-wishlist-item__move-to-cart btn btn--secondary" data-move-to-cart>
        {{#isInCart}}Moved to bag{{/isInCart}}
        {{^isInCart}}Move to bag{{/isInCart}}
      </a>

      <div class="cart-wishlist-item__remove" data-remove-wishlist-item>
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>icon-trash</title>
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-156.000000, -180.000000)" fill="#231F20">
                    <g transform="translate(24.000000, 0.000000)">
                        <g transform="translate(49.000000, 91.000000)">
                            <g transform="translate(83.000000, 89.000000)">
                                <path d="M11.5963429,14.4281905 L4.2904381,14.4281905 L2.92815238,4.18514286 L12.9464381,4.18514286 L11.5963429,14.4281905 Z M6.8192,1.78666667 C7.0744381,1.50780952 7.4584381,1.37142857 7.99329524,1.37142857 C8.52586667,1.37142857 8.91215238,1.504 9.1399619,1.76609524 C9.4112,2.07695238 9.45310476,2.544 9.44472381,2.81371429 L6.4344381,2.81371429 C6.45729524,2.5287619 6.54034286,2.09295238 6.8192,1.78666667 Z M15.8729143,2.81371429 L14.5106286,2.81371429 L10.8176762,2.81371429 C10.826819,2.3512381 10.7506286,1.53447619 10.1837714,0.876190476 C9.6832,0.294857143 8.9464381,-3.55271368e-15 7.99329524,-3.55271368e-15 C7.06377143,-3.55271368e-15 6.32777143,0.290285714 5.80586667,0.863238095 C5.21539048,1.51085714 5.08358095,2.32457143 5.0599619,2.81371429 L1.36167619,2.81371429 L0.000152380952,2.81371429 L0.000152380952,4.18514286 L1.54377143,4.18514286 L3.08891429,15.799619 L12.7986286,15.799619 L14.3292952,4.18514286 L15.8729143,4.18514286 L15.8729143,2.81371429 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
      </div>
    </div>
  </div>
`;

export default (list_product, container) => {
  try {
    list_product.isInCart = _swat.platform.isInDeviceCart(list_product.epi);

    list_product.pr_formatted = (window.Shopify.country === 'US') ? formatMoney(Number(list_product.pr) * 100, theme.moneyFormat) : 
    formatMoney(Math.ceil(Number(list_product.pr) * window.Shopify.currency.rate) * 100, theme.moneyFormat);

    // Swym doesn't allow html tags
    list_product.pr_formatted = list_product.pr_formatted.replace("<span class='money'>", '').replace('</span>', '');

    // console.log('list_product', list_product.dt, list_product.vi);
    // console.log('list_product.variants', list_product.variants);

    list_product.du = list_product.du.replace(`https://${window.location.host}`, `https://${window.location.host}${window.Shopify.routes.root.slice(0, -1)}`);

    const renderedProductTile = SwymUtils.renderTemplateString(productTileMarkup, list_product);
    container.insertAdjacentHTML('beforeend', renderedProductTile);

    // Cleanup variant and price once rendered
    let option_html = '';
    if (typeof list_product.variants === 'undefined') {
      if (typeof list_product.vi !== 'undefined') {
        const item_options = (list_product.vi.includes('/')) ? list_product.vi.split('/') : list_product.vi.split(' ');

        if (item_options.length === 1) {
          option_html += `<span class="cart-wishlist-item__misc">${list_product.vi}</span>`;
        } else if (item_options.length > 1) {
          // console.log(item_options)
          const size = _.last(item_options);
          item_options.pop();
          const color = item_options.join(' ');

          option_html += `<span class="cart-wishlist-item__color">Color: ${color}</span>`;
          option_html += `<span class="cart-wishlist-item__size">Size: ${size}</span>`;
        }
      }
    } else {
      const item_options = (typeof list_product.variants === 'object') ? list_product.variants : JSON.parse(list_product.variants);
      const option_values = (Object.keys(item_options[0])[0].indexOf('/') === -1) ? Object.values(item_options[0])[0].split(' / ') : Object.keys(item_options[0])[0].split(' / ');
      _.each(option_values, (option_value, i) => {
        if (i === 0) {
          if (option_values.length > 1) {
            option_html += `<span class="cart-wishlist-item__color">Color: ${option_value}</span>`;
          } else {
            option_html += `<span class="cart-wishlist-item__misc">${option_value}</span>`;
          }
        }

        if (i === 1) {
          option_html += `<span class="cart-wishlist-item__size">Size: ${option_value}</span>`;
        }
      });
    }

    return option_html;
  } catch (e) {
    console.log(e);
  }
};
